import React from 'react';
import { Moment } from "moment";
import { useDispatch } from "react-redux";
import { WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { updateMovement } from '@features/whereabouts/store/editMovements.duck';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import { MovementImage } from "../../../atoms/MovementImage";
import { BodyRegular } from "../../../atoms/fonts/Body";

export function MultipleLeaveItem(props: Props) {
  const {activeDay, activeUserId} = props;
  const dispatch = useDispatch();

  const onLeaveTypeSelected = (wo: WhereaboutsOption) => {
    dispatch(updateMovement({selectedOption: wo, locationId: 0, activeDay: activeDay?.format(DATE_FORMAT), activeUserId}));
  }

  const onClick = (e: any) => {
    e.stopPropagation();
    dispatch(openDialogWithPayload({
      payload: { onSelect: onLeaveTypeSelected },
      activeDialog: DialogIdentifiers.SelectLeaveTypeDialog
    }))
  }

  return (<div className="activity" onClick={onClick}>
    <MovementImage src={'/assets/icons/multiple-icon.svg'} alt={''}/>
    <BodyRegular weight={600}>Add Leave</BodyRegular>
  </div>)
}

interface Props {
  activeDay?: Moment;
  activeUserId?: string;
}
